import React from "react";
import Posts from "../components/Posts/Posts";
import Sidebar from "../components/Sidebar/Sidebar";

const Home = () => {
  return (
    <section className="wrapper">
      <Sidebar />
      {/* <!-- posts container  --> */}
      <Posts />
      {/* <!-- posts container ends --> */}
    </section>
  );
};

export default Home;
